import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/error',
    component: () => import('@/views/error'),
    meta: {title: '异常'}
  }, {
    path: '/',
    redirect: '/su/login'
  }, {
    path: '/su/login',
    name: 'supplierLogin',
    component: () => import('@/views/supplier/login'),
    meta: {title: '供应商-登录'}
  }, {
    path: '/su/register',
    name: 'supplierRegister',
    component: () => import('@/views/supplier/register'),
    meta: {title: '供应商-注册'}
  }, {
    path: '/su/forget/password',
    name: 'supplierForgetPassword',
    component: () => import('@/views/supplier/forget/password'),
    meta: {title: '供应商-找回密码'}
  }, {
    path: '/su/forget/account',
    name: 'supplierForgetAccount',
    component: () => import('@/views/supplier/forget/account'),
    meta: {title: '供应商-找回账号和密码'}
  }, {
    path: '/pu/login',
    name: 'purchaserLogin',
    component: () => import('@/views/purchaser/login'),
    meta: {title: '采购单位-登录'}
  }, {
    path: '/pu/register',
    name: 'purchaserRegister',
    component: () => import('@/views/purchaser/register'),
    meta: {title: '采购单位-注册'}
  // }, {
  //   path: '/unit/join',
  //   name: 'unitJoin',
  //   component: () => import('@/views/unit/join'),
  //   meta: {title: '单位加入'}
  }]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 竞价网,竞采网,竞价采购网,高校网上竞价采购平台-高校采购,高校网上采购,询价采购,分散采购,零星采购,竞价采购,高校招标,仪器设备,实验器材,试剂,耗材'
  }

  if (to.matched.length === 0) { // 匹配前往的路由不存在
    from.name ? next({name: from.name}) : next('/error') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
  } else {
    next() // 如果匹配到正确跳转
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js